<template>
  <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <!-- <Footer /> -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      val: 2,
    }
  },
  mounted() {
    this.val = this.$getItem("version")
    this.$removeItem("apiKey")
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif, "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* font-size: var(--middleFont); */
  color: var(--defaultColor);
  /* padding-bottom: 100px; */
  height: 100%;
}
</style>
